import { CSSProperties } from '@material-ui/core/styles/withStyles'

export const titleCase: CSSProperties = {
  textTransform: 'capitalize',
}
